module.exports = __webpack_public_path__ + "static/media/delete.552cafe8.svg";